import React from "react";
import { StyledButton } from "./style";
import { useNavigate } from "react-router-dom";
export const Button = ({ children, ...rest }) => {
  const navigate = useNavigate()
  return (
    <StyledButton onClick={() => navigate('/contatos')} {...rest}>
      {children}
    </StyledButton>
  );
};
